import React from 'react';
import Typography from '@hpstellar/core/Typography/Typography.js';
import {MetricsElement} from 'react-metrics';

import Drawer from '../../../page/components/drawer';
import RadioButton from '../../../ui/components/radio-button';
import RadioButtonGroup from '../../../ui/components/radio-button-group';

import './configuration-drawer.less'

const configurationDrawer = ({ 
    drawerPosition = 'right', 
    isOpen, 
    toggleDrawer, 
    title='Choose Your Option',
    subheader,
    className,
    HeaderComponent,
    onChange=()=>{},
    configurations
}) => {
    if (configurations && configurations.length > 0) {
        return (<Drawer 
                    open={isOpen} 
                    position={drawerPosition} 
                    lazyLoad={true}
                    className={`configuration-drawer ${className ? ` ${className}` : ''}`} 
                    title={title}>
                    <div className='hp-icon close' tabIndex={0} onClick={toggleDrawer}></div>
                    <div className='clearfix'>
                        <Typography
                        tag="h4"
                        variant="headingSubheader"
                        >
                            {subheader}
                        </Typography>
                        {HeaderComponent && HeaderComponent()}
                    </div>
                    <RadioButtonGroup name='carepack-module' onChange={onChange}>
                        {configurations.map((c,i) => (
                            <RadioButton 
                                    key={`${i}-${c.checked}`} 
                                    label={c.label} 
                                    title={c.title} 
                                    info={c.info}
                                    checked={c.checked}
                                    value={c.value}
                                    colorHex={c.colorHex}
                                    imageUrl={c.imageUrl}
                                    variation='tile'
                                    />
                        ))}
                    </RadioButtonGroup>
                </Drawer>)
    }
    return null;
}

export default configurationDrawer;